import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Programs', path: '/programs' },
  { label: 'Events', path: '/events' },
  { label: 'Board Members', path: '/board-members' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  return (
    <header className={`site-header${scrolled ? ' scrolled' : ''}`}>
      <div className="topbar">
        <div className="container topbar-inner">
          <Link to="/" className="brand">
            <img src="/img/newbirthlogo.png" alt="New Birth Logo" />
            <span>New Birth</span>
          </Link>
          <div className="topbar-info">
            <div className="info-item">
              <div className="info-icon">🗓</div>
              <div>
                <strong>Office Hour</strong>
                <p>Mon – Fri, 8:00 – 9:00</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">📞</div>
              <div>
                <strong>Call Us</strong>
                <p>+1-416-857-9811</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon">✉</div>
              <div>
                <strong>Email Us</strong>
                <p>nbirthcci@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav className="main-nav">
        <div className="container nav-inner">
          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>

          <ul className={`nav-links${menuOpen ? ' open' : ''}`}>
            {navLinks.map(({ label, path }) => (
              <li key={path}>
                <Link
                  to={path}
                  className={location.pathname === path ? 'active' : ''}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          <a
            href="https://www.paypal.com/donate"
            className="donate-btn"
            target="_blank"
            rel="noreferrer"
          >
            Click to Donate
          </a>
        </div>
      </nav>
    </header>
  );
}
